import DealList from './DealList';

export default DealList;
